import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import AccountMenu from "./AccountMenu";
import { Grid } from "@material-ui/core";
import Notifier from "./Notifier";
import { getConfig } from "../../config/configuration";

const TopBar: React.FC = () => {

  const [additionalLogo, setAdditionalLogo] = React.useState<string | null>(null);

  React.useEffect(() => {
    getConfig().then(config => {
      setAdditionalLogo(config.additionalLogo || null);
    });
  }, []);

  return (
    <AppBar color="inherit" position="static" elevation={0}>
      <Toolbar>
        <Grid container alignItems="center" onClick={() => window.location.assign("/")} style={{ cursor: "pointer", width: "initial" }}>
          <Grid item>
            <img src="logo.png" style={{ height: '48px', marginTop: '4px' }} />
          </Grid>
          {
            !!additionalLogo && (<Grid item>
              <img src={additionalLogo} style={{ height: '48px', marginTop: '4px', marginLeft: '4px' }} />
            </Grid>)
          }

        </Grid>

        <div style={{ flexGrow: 1 }}></div>
        <Notifier />
        <AccountMenu />
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
